import { useState } from "react";

var C = {
  bg:"#0F1117", surface:"#1A1D27", border:"#2E3248",
  accent:"#F5A623", blue:"#4A90D9", text:"#E8EAF0", dim:"#9AA0C0", muted:"#6B7094",
};
var FM = { fontFamily:"'DM Mono','Courier New',monospace" };

function Section(props) {
  return (
    <div style={{ marginBottom:24 }}>
      <div style={{ fontSize:11, fontWeight:700, color:C.accent, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10, ...FM }}>{props.title}</div>
      <div style={{ fontSize:12, color:C.dim, lineHeight:1.8 }}>{props.children}</div>
    </div>
  );
}

function TermsContent() {
  return (
    <div>
      <div style={{ fontSize:11, color:C.muted, marginBottom:24, ...FM }}>Last updated: March 2026 &nbsp;·&nbsp; MyChoreHabit LLC</div>
      <Section title="1. Acceptance of Terms">
        By accessing or using ChoreHabit, you agree to be bound by these Terms of Service. If you do not agree, do not use the service. These terms apply to all users, including free and paid subscribers.
      </Section>
      <Section title="2. Description of Service">
        ChoreHabit is a fleet and equipment maintenance tracking platform offered by MyChoreHabit LLC. The service includes maintenance interval tracking, crew management tools, service history logging, and related features. Features vary by subscription plan.
      </Section>
      <Section title="3. Accounts and Subscriptions">
        You are responsible for maintaining the confidentiality of your account credentials. You must provide accurate information during registration. Paid subscriptions are billed monthly or annually as selected. The Founding Member discount (50% off for life) is available to the first 10 paying customers and is forfeited permanently upon cancellation or downgrade to the Free plan.
      </Section>
      <Section title="4. Acceptable Use">
        You agree not to use ChoreHabit to store false or misleading equipment data, violate any applicable laws, attempt to reverse engineer or copy the platform, or interfere with the service or other users' access. We reserve the right to suspend accounts that violate these terms.
      </Section>
      <Section title="5. Data and Privacy">
        We collect and process data as described in our Privacy Policy. You retain ownership of your equipment and operational data. We do not sell your data to third parties. By using ChoreHabit, you grant us a limited license to store and process your data for the purpose of providing the service.
      </Section>
      <Section title="6. Free Trial">
        New accounts receive a 30-day free trial. No credit card is required to start. After the trial period, continued access to paid features requires a paid subscription. Data is retained for 30 days after trial expiration before deletion.
      </Section>
      <Section title="7. Limitation of Liability">
        ChoreHabit is provided "as is." MyChoreHabit LLC is not liable for any damages arising from missed maintenance alerts, equipment failures, data loss, or service interruptions. Our total liability is limited to the amount you paid us in the preceding 12 months.
      </Section>
      <Section title="8. Termination">
        Either party may terminate the relationship at any time. You may cancel your subscription from the Account Settings screen. Upon termination, your data will be retained for 30 days before deletion. Founding Member status is permanently forfeited upon cancellation.
      </Section>
      <Section title="9. Changes to Terms">
        We may update these Terms at any time. We will notify you of material changes via email or in-app notification. Continued use after notification constitutes acceptance of the updated Terms.
      </Section>
      <Section title="10. Contact">
        Questions about these Terms? Contact us at support@mychorehabit.com or MyChoreHabit LLC, Tetonia, Idaho 83452.
      </Section>
    </div>
  );
}

function PrivacyContent() {
  return (
    <div>
      <div style={{ fontSize:11, color:C.muted, marginBottom:24, ...FM }}>Last updated: March 2026 &nbsp;·&nbsp; MyChoreHabit LLC</div>
      <Section title="Information We Collect">
        We collect information you provide directly: your name, email, company name, and equipment data you enter. We also collect usage data including log entries, maintenance records, and service history. We use browser local storage to persist your data between sessions.
      </Section>
      <Section title="How We Use Your Information">
        We use your information to provide and improve ChoreHabit, send maintenance alerts and reminders, process subscription payments through Stripe, and respond to support requests. We do not use your data for advertising purposes.
      </Section>
      <Section title="Data Sharing">
        We do not sell, rent, or share your personal information with third parties for their marketing purposes. We share data only with service providers necessary to operate ChoreHabit (such as Stripe for payment processing) and as required by law.
      </Section>
      <Section title="Data Storage and Security">
        Your data is stored securely. Equipment data is stored locally in your browser using localStorage and, when a backend is enabled, on our secure servers. We use industry-standard encryption for data in transit. We cannot guarantee absolute security, but we take reasonable precautions.
      </Section>
      <Section title="Cookies and Tracking">
        ChoreHabit uses minimal tracking. We store session data and preferences in browser localStorage. We do not use third-party advertising trackers or sell browsing data.
      </Section>
      <Section title="Your Rights">
        You may request access to, correction of, or deletion of your personal data at any time by contacting support@mychorehabit.com. You may also delete your account directly from Account Settings, which will remove your data within 30 days.
      </Section>
      <Section title="Children's Privacy">
        ChoreHabit is not directed at children under 13. We do not knowingly collect personal information from children under 13.
      </Section>
      <Section title="Changes to This Policy">
        We may update this Privacy Policy periodically. We will notify you of material changes via email or in-app notification. The date at the top of this page reflects the most recent update.
      </Section>
      <Section title="Contact">
        Privacy questions or requests: support@mychorehabit.com or MyChoreHabit LLC, Tetonia, Idaho 83452.
      </Section>
    </div>
  );
}

function SupportContent() {
  var s1=useState(""); var subject=s1[0]; var setSubject=s1[1];
  var s2=useState(""); var message=s2[0]; var setMessage=s2[1];
  var s3=useState(false); var sent=s3[0]; var setSent=s3[1];

  var inp = { background:"#13151F", border:"1px solid #2E3248", borderRadius:8, padding:"11px 13px", color:"#E8EAF0", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", outline:"none", width:"100%", boxSizing:"border-box" };
  var lbl = { fontSize:10, color:C.muted, letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, ...FM, display:"block", marginBottom:6 };

  var FAQS = [
    { q:"How do I add equipment?", a:"From your dashboard, tap 'Add' in the quick nav row, or go to the Fleet screen and tap the + button. You can look up vehicles by VIN or search by make and model for auto-fill." },
    { q:"How does the 30-day trial work?", a:"Your trial starts the day you create your account. All paid features are available during the trial. No credit card is required. After 30 days, you can upgrade to a paid plan from Account Settings." },
    { q:"What is the Founding Member discount?", a:"The first 10 paying customers lock in 50% off their chosen plan for life. The discount stays active as long as your subscription is continuous — it is permanently forfeited if you cancel or drop to the Free plan." },
    { q:"Can crew members see cost data?", a:"No. Crew members have a simplified view — they can log hours, submit service requests, and mark maintenance complete, but cannot see cost data, edit equipment specs, or access billing information." },
    { q:"How do I add crew members?", a:"Crew features are available on the Captain & Crew and Pro plans. Go to Account Settings or use the Manage Users option from your dashboard menu." },
    { q:"What happens to my data if I cancel?", a:"Your data is retained for 30 days after cancellation before deletion. You can export your service history from the Weekly Report screen before canceling." },
  ];

  return (
    <div>
      {/* Contact card */}
      <div style={{ background:"rgba(245,166,35,0.08)", border:"1px solid "+C.accent, borderRadius:14, padding:"18px 16px", marginBottom:24 }}>
        <div style={{ fontSize:13, fontWeight:700, color:C.accent, marginBottom:4 }}>Get in Touch</div>
        <div style={{ fontSize:12, color:C.dim, lineHeight:1.7, marginBottom:14 }}>
          We're a small team building ChoreHabit from eastern Idaho. We read every message and usually respond within one business day.
        </div>
        <a href="mailto:support@mychorehabit.com" style={{ display:"flex", alignItems:"center", gap:10, background:C.surface, border:"1px solid "+C.border, borderRadius:10, padding:"12px 14px", textDecoration:"none" }}>
          <span style={{ fontSize:20 }}>📧</span>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:C.text }}>support@mychorehabit.com</div>
            <div style={{ fontSize:11, color:C.muted, marginTop:1 }}>Tap to open your email app</div>
          </div>
        </a>
      </div>

      {/* FAQ */}
      <div style={{ fontSize:11, fontWeight:700, color:C.accent, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12, ...FM }}>Frequently Asked Questions</div>
      {FAQS.map(function(faq, i) {
        return (
          <div key={i} style={{ background:C.surface, border:"1px solid "+C.border, borderRadius:12, padding:"14px 16px", marginBottom:8 }}>
            <div style={{ fontSize:12, fontWeight:700, color:C.text, marginBottom:6 }}>{faq.q}</div>
            <div style={{ fontSize:11, color:C.dim, lineHeight:1.6 }}>{faq.a}</div>
          </div>
        );
      })}

      {/* Contact form */}
      <div style={{ marginTop:24 }}>
        <div style={{ fontSize:11, fontWeight:700, color:C.blue, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12, ...FM }}>Send a Message</div>
        {sent ? (
          <div style={{ background:"rgba(76,175,110,0.1)", border:"1px solid #4CAF6E", borderRadius:12, padding:"20px 16px", textAlign:"center" }}>
            <div style={{ fontSize:24, marginBottom:10 }}>✅</div>
            <div style={{ fontSize:13, fontWeight:700, color:"#4CAF6E", marginBottom:4 }}>Message sent!</div>
            <div style={{ fontSize:11, color:C.dim }}>We'll get back to you within one business day.</div>
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div><label style={lbl}>Subject</label><input style={inp} placeholder="What do you need help with?" value={subject} onChange={function(e){ setSubject(e.target.value); }} /></div>
            <div><label style={lbl}>Message</label><textarea style={{ ...inp, resize:"none", minHeight:100, lineHeight:1.6 }} rows={4} placeholder="Describe your issue or question..." value={message} onChange={function(e){ setMessage(e.target.value); }} /></div>
            <button disabled={!subject.trim()||!message.trim()} onClick={function(){ setSent(true); }} style={{ width:"100%", background:subject.trim()&&message.trim()?C.accent:"#1E2230", border:"none", borderRadius:10, color:subject.trim()&&message.trim()?"#0F1117":C.muted, fontSize:12, ...FM, fontWeight:700, padding:13, cursor:subject.trim()&&message.trim()?"pointer":"not-allowed", textTransform:"uppercase", letterSpacing:"0.08em" }}>Send Message</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function LegalScreen(props) {
  var page = props.page || "support"; // "terms" | "privacy" | "support"
  var onBack = props.onBack || function(){};

  var css = "@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap'); *{box-sizing:border-box;margin:0;padding:0;} ::-webkit-scrollbar{width:4px;} ::-webkit-scrollbar-thumb{background:#2E3248;border-radius:2px;}";

  var titles = { terms:"Terms of Service", privacy:"Privacy Policy", support:"Support" };

  return (
    <div style={{ ...FM, background:C.bg, minHeight:"100vh", color:C.text, display:"flex", flexDirection:"column", alignItems:"center" }}>
      <style>{css}</style>
      <div style={{ width:"100%", maxWidth:480 }}>
        {/* Header */}
        <div style={{ padding:"18px 20px 16px", display:"flex", alignItems:"center", gap:12, borderBottom:"1px solid "+C.border }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:C.blue, fontSize:22, cursor:"pointer", padding:"0 6px 0 0", lineHeight:1 }}>{"<"}</button>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13, fontWeight:700, color:C.accent, letterSpacing:"0.15em", textTransform:"uppercase" }}>{titles[page]}</div>
            <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>ChoreHabit &nbsp;·&nbsp; MyChoreHabit LLC</div>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding:"20px 20px 60px" }}>
          {page==="terms"   && <TermsContent />}
          {page==="privacy" && <PrivacyContent />}
          {page==="support" && <SupportContent />}
        </div>
      </div>
    </div>
  );
}
